import { Device, ApiDeviceType } from './device';
import { Env } from '../env';

export enum SiteType {
  SOLOARE = 'SOLOARE',
  CLUB = 'CLUB',
  TRYLION = 'TRYLION',
}

/** HTMLから渡ってくるグローバル変数（TRYLION.Env として渡ってくる）*/
export interface JsEnv {
  PAGE: any;
  FUNCTIONS: any;
  SETTING: FrontendSetting;
  SITE_TYPE: SiteType;
  DEVICE: Device;
  API_DEVICE_TYPE: ApiDeviceType;
  USER_INFO: any;
}

export interface FrontendSetting {
  searchFront: SearchFrontSetting;
  userPublicApi: UserPublicApiSetting;
  soloareApi: SoloareApiSetting;
  clubApi: ClubApiSetting;
  rr: RrSetting;
  tonerIcons: string[];
  cdn: CdnSetting;
  clubFront: ClubFrontSetting;
  soloareFront: SoloareFrontSetting;
  rtoaster: RtoasterSetting;
  production: boolean;
}

export interface SearchFrontSetting {
  urlBase: string;
}

export interface UserPublicApiSetting {
  urlBase: string;
  authorizationCode: string;
}

export interface SoloareApiSetting {
  urlBase: string;
}

export interface ClubApiSetting {
  urlBase: string;
}

export interface RrSetting {
  apiKey: string;
  urlBase: string;
}

export interface CdnSetting {
  urlBase: string;
}

export interface ClubFrontSetting {
  urlBase: string;
}

export interface SoloareFrontSetting {
  urlBase: string;
}

export interface RtoasterSetting {
  accountId: string;
}

export const isSoloare = (siteType: SiteType) => siteType === SiteType.SOLOARE

export const isClub = (siteType: SiteType) => siteType === SiteType.CLUB

/// サイト区分値
export type SiteTypeValue = '1' | '2' | '3';
export const getSiteTypeValue = (): SiteTypeValue => {
  switch (Env.SITE_TYPE) {
    case SiteType.CLUB :
      return '1';
    case SiteType.SOLOARE :
      return '2';
    default :
      return '3';
  }
}
